import { DashboardEntry } from "./dashboard-entry";
import { DashboardWidget } from "./dashboard-widget";
import { For, type Component } from "solid-js";
import { getPluginService } from "../services/plugin/plugin-service";
import { type PageIdentifier, type PluginEntry } from "../types";
import SettingsIcon from "../settings/settings-icon.svg?component-solid";

type DashboardProps = {
  pluginEntries: PluginEntry[];
  onNavigate: (pageId: PageIdentifier) => void;
};

export const Dashboard: Component<DashboardProps> = (props) => {
  const enabledPluginEntries = () =>
    getPluginService().sortPluginEntries(props.pluginEntries.filter((pE) => pE.enabled));

  return (
    <div class="Dashboard">
      <For each={enabledPluginEntries()}>
        {(entry) => <DashboardEntry entry={entry} onNavigate={props.onNavigate} />}
      </For>

      <DashboardWidget title="Settings" widgetIcon={SettingsIcon} onClick={() => props.onNavigate("settings")} />
    </div>
  );
};
